"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoDefaults = exports.audioDefaults = exports.publishDefaults = void 0;
const options_1 = require("./options");
exports.publishDefaults = {
    audioBitrate: options_1.AudioPresets.speech.maxBitrate,
    dtx: true,
    simulcast: true,
    screenShareEncoding: options_1.ScreenSharePresets.h1080fps15.encoding,
    stopMicTrackOnMute: false,
};
exports.audioDefaults = {
    autoGainControl: true,
    channelCount: 1,
    echoCancellation: true,
    noiseSuppression: true,
};
exports.videoDefaults = {
    resolution: options_1.VideoPresets.h540.resolution,
};
//# sourceMappingURL=defaults.js.map